export function filterContent(content, subscriptions, hasMigratedToNewTierExpansion) {
    let available = Object.keys(subscriptions.values)
    hasMigratedToNewTierExpansion && available.push('maLoyaltyConsent')
    const isUserEIP = available.includes('maMarketingEmailEIPNotification')

    const marketingCommunicationsItems = {}
    const rewardsProgramItems = {}

    content.items.forEach((item) => {
        // generic page items, e.g. intro paragraph
        if (item.type === 'ynapteaser') {
            marketingCommunicationsItems[item.contentID] = item // the contentID is irrelevent
            return
        }

        // get ID of option to match up with userSubscriptions response (and de-duplicate)
        const itemKey = item.items?.find((child) => child.layoutVariant === 'consent-checkbox').ID

        // only include consent options that match a subscription key
        if (!available.includes(itemKey)) {
            return
        }

        // is the item tagged EIP?
        const isItemEIP = item.tags?.filter((tag) => tag?.children?.[0]?.name === 'eip').length > 0
        // is the item tagged loyalty-rewards?
        const isItemLoyaltyRewards =
            item.tags?.filter((tag) => tag?.children?.[0]?.name === 'loyalty-rewards').length > 0

        if (isItemLoyaltyRewards) {
            rewardsProgramItems[itemKey] = item
            return
        }

        if (isUserEIP) {
            if (isItemEIP) {
                marketingCommunicationsItems[itemKey] = item
            } else {
                // do not overwrite EIP content with standard
                if ((!Object.hasOwn(marketingCommunicationsItems, itemKey), itemKey)) {
                    marketingCommunicationsItems[itemKey] = item
                }
            }
        } else if (!isItemEIP) {
            marketingCommunicationsItems[itemKey] = item
        }
    })

    return {
        marketingCommunicationsItems: Object.values(marketingCommunicationsItems) || [],
        rewardsProgramItems: Object.values(rewardsProgramItems) || [],
    }
}
